import { render, staticRenderFns } from "./punishNotice.vue?vue&type=template&id=64a54252&scoped=true&"
import script from "./punishNotice.vue?vue&type=script&lang=js&"
export * from "./punishNotice.vue?vue&type=script&lang=js&"
import style0 from "./punishNotice.vue?vue&type=style&index=0&id=64a54252&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a54252",
  null
  
)

export default component.exports